/*
 * BBC - Rap Map - Rapper of the week button
 * Opens current rapper of the week profile
 *
 * @author Matt Haynes <matt@joipolloi.com>
 * @package BBC Rap Map
 */

import React from 'react';
import GoldMic from './assets/MIC-Contestant-season3-potw.png';

const RapperOfTheWeekButton = ({
    rapperOfTheWeek: {
        id,
    },
    setSelectedIndex,
    setViewport,
    rapperOfTheWeekData: {
        geometry,
    },
    FlyToInterpolator,
    viewport,
    showWarning,
}) => {
    const [longitude, latitude] = geometry.coordinates;
    const updateViewport = () => {
        setViewport && setViewport({
            ...viewport,
            latitude,
            longitude,
            transitionInterpolator: new FlyToInterpolator({ speed: 2 }),
            transitionDuration: 'auto',
            zoom: 14,
        })
    };

    return (
        <button
            className={`Map__RapperOfTheWeek ${showWarning ? '' : 'Map__RapperOfTheWeek--WarningHidden'}`}
            onClick={() => {
                setSelectedIndex(id);
                updateViewport();
            }}
        >
            <img
                src={GoldMic}
                width="20"
                height="20"
                alt=""
            />
            DJ Target's Pick of the Week
        </button>
    );
}

export default RapperOfTheWeekButton;
